import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppContext from 'context/Context';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { Button, Modal } from 'react-bootstrap';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';

export const DeleteModal = ({
  openDeleteModal,
  setOpenDeleteModal,
  element,
  setDeleting
}) => {
  const {
    config: { isDark }
  } = useContext(AppContext);
  const handleClose = () => {
    setOpenDeleteModal(false);
  };

  return (
    <Modal
      show={openDeleteModal}
      onHide={handleClose}
      contentClassName="border"
      centered
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="bg-light px-card border-bottom-0"
      >
        <h5 className="mb-0">¿Está seguro que desea eliminar {element}?</h5>
      </Modal.Header>
      <Modal.Body>
        <ModalButtonsContainer>
          <Button
            size="sm"
            variant="secondary"
            onClick={() => setOpenDeleteModal(false)}
          >
            <span>
              <FontAwesomeIcon icon="fa-xmark" style={{ marginRight: 5 }} />
              &nbsp;Cancelar
            </span>
          </Button>
          <Button
            size="sm"
            variant="danger"
            onClick={() => {
              setDeleting(openDeleteModal);
              setOpenDeleteModal(false);
            }}
          >
            <span>
              {' '}
              <FontAwesomeIcon icon="trash-can" style={{ marginRight: 5 }} />
              Eliminar
            </span>
          </Button>
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

DeleteModal.propTypes = {
  openDeleteModal: PropTypes.bool,
  setOpenDeleteModal: PropTypes.func,
  element: PropTypes.string,
  setDeleting: PropTypes.func
};
